var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegetarian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 26,
    viewBox: "0 0 7 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313",
    transform: "translate(-112 -384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MDI_carrot",
    "data-name": "MDI / carrot",
    transform: "translate(104 382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_carrot",
    "data-name": "Path / carrot",
    d: "M14.4,8.4l-.16.8H12.4a.4.4,0,0,0,0,.8h1.68l-.8,4H11.6a.4.4,0,1,0,0,.8h1.52l-.32,1.6a1.6,1.6,0,0,1-3.2,0l-.8-4H10a.4.4,0,0,0,0-.8H8.64L8,8.4A2.449,2.449,0,0,1,9.832,6.232L8.72,4.624a.8.8,0,0,1,1.32-.912l.36.528V2.8a.8.8,0,0,1,1.6,0V4.624l1.2-1.392a.778.778,0,0,1,1.112-.088A.8.8,0,0,1,14.4,4.272L12.7,6.28A2.409,2.409,0,0,1,14.4,8.4Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "V",
    transform: "translate(113 408)",
    fontSize: 8,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegetarian);
export default __webpack_public_path__ + "static/media/vegetarian.9fce8b88b6db3f02dfa8dc84da45f874.svg";
export { ForwardRef as ReactComponent };